import { getAuthToken } from "../context/auth-context";
import { CALL_API } from "../context/constValues";
import Swal from "sweetalert2";

// Obtener todos los usuarios
export async function getAllUsuario() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/usuario`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error("No se encontró información");
  }
  return data.result;
}

// Obtener usuario por ID
export async function getUsuarioById(idUsuario) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/usuario/${idUsuario}`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error("No se encontró información");
  }
  return data.result;
}

// Obtener usuarios por tipo de usuario
export async function getUsuarioByTipoUsuario(idTipoUsuario) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/usuario-tipo/${idTipoUsuario}`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message ? data.message : "Error");
  }
  return data.result;
}

// Obtener asignaciones de un usuario
export async function getUserAsignaciones(idUsuario) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/asignacion/Verasignaciones`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  console.log(data);
  if (!response.ok) {
    throw new Error(data.message);
  }
  return data.result;
}

// Obtener credenciales del usuario actual
export async function getUserCredentials() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/user-credentials`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message);
  }
  return data.userData;
}

// Registrar un nuevo usuario
export async function signUp(userObject) {
  const {
    Fechadenacimiento,
    RegistroProfesional,
    apellido,
    cedula,
    ciudad,
    direccion,
    nombre,
    password,
    subtipo,
    telefono,
    tipousuario,
    usuario,
    imagen,
    Fechadeingreso,
    sexo,
    estadocivil,
    hijos,
    antpol,
    departamento,
    barrio,
    metododepago
  } = userObject;
  const nombrecompleto = nombre + " " + apellido;
  const token = getAuthToken();
  const formData = new FormData();
  formData.append("Fechadenacimiento", Fechadenacimiento);
  formData.append("RegistroProfesional", RegistroProfesional);
  formData.append("apellido", apellido);
  formData.append("cedula", cedula);
  formData.append("ciudad", ciudad);
  formData.append("direccion", direccion);
  formData.append("nombre", nombrecompleto);
  formData.append("password", password);
  formData.append("subtipo", subtipo);
  formData.append("telefono", telefono);
  formData.append("tipousuario", tipousuario);
  formData.append("usuario", usuario);
  formData.append("Fechadeingreso", Fechadeingreso);
  formData.append("sexo", sexo);
  formData.append("estadocivil", estadocivil);
  formData.append("hijos", hijos);
  formData.append("antpol", antpol);
  formData.append("departamento", departamento);
  formData.append("barrio", barrio);
  formData.append("image", imagen);
  formData.append("metododepago", metododepago ? metododepago : "TRANSFERENCIA");
  const response = await fetch(`${CALL_API}/usuario`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: formData,
  });

  const data = await response.json();
  if (!response.ok) {
    console.log(data.messege);
    throw new Error(`${data.message}`);
  }

  return data.isSaved;
}

// Actualizar datos de usuario existente
export async function updateUsuario(usuarioObject) {
  const {
    Usuario,
    tipousuario,
    subtipo,
    Fechaingreso,
    RegistroProfesional,
    Nombre,
    Cedula,
    sexo,
    estadocivil,
    hijos,
    Fechadenacimiento,
    antpol,
    Telefono,
    departamento,
    Ciudad,
    Direccion,
    IdUsuario,
    imagen,
    barrio,
    imgvalue,
    metododepago
  } = usuarioObject;
  const token = getAuthToken();
  const formData = new FormData();
  formData.append("Fechadenacimiento", Fechadenacimiento);
  formData.append("registroprofesional", RegistroProfesional);
  formData.append("Cedula", Cedula);
  formData.append("Ciudad", Ciudad);
  formData.append("Direccion", Direccion);
  formData.append("Nombre", Nombre);
  formData.append("subtipo", subtipo);
  formData.append("Telefono", Telefono);
  formData.append("tipousuario", tipousuario);
  formData.append("Usuario", Usuario);
  formData.append("Fechaingreso", Fechaingreso);
  formData.append("sexo", sexo);
  formData.append("estadocivil", estadocivil);
  formData.append("hijos", hijos);
  formData.append("antpol", antpol);
  formData.append("departamento", departamento);
  formData.append("IdUsuario", IdUsuario);
  formData.append("imagen", imagen);
  formData.append("barrio", barrio);
  formData.append("image", imgvalue);
  formData.append("metododepago", metododepago ? metododepago : "TRANSFERENCIA");
  const response = await fetch(`${CALL_API}/updateusuario`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: formData,
  });

  const data = await response.json();
  if (!response.ok) {
    console.log(data.message);
    throw new Error(data.message);
  }
  return data;
}

// Restablecer contraseña de un usuario
export async function resetPassword(usuarioObject) {
  console.log(usuarioObject)
  const { contraseña1, IdUsuario } = usuarioObject;
  console.log(IdUsuario)
  const token = getAuthToken();
  const result = await fetch(`${CALL_API}/reset/${IdUsuario}`, {
    method: "PATCH",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      newPassword: contraseña1,
      IdUsuario: IdUsuario
    }),
  });

  const data = await result.json();

  if (!result.ok) {
    console.log(data.messege);
    throw new Error(data.message);
  }

  return data.isReset;
}

// Iniciar sesión
export async function login(usuarioObject) {
  const { usuario, password } = usuarioObject;
  const response = await fetch(`${CALL_API}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      usuario: usuario,
      password: password,
    }),
  });

  const data = await response.json();
  console.log(data)
  if (!response.ok) {
    Swal.fire({
      title: "¡Error!",
      text: `${data.message}`,
      icon: "error",
      confirmButtonText: "Ok",
    });
    console.log(data.messege);
  }

  return data;
}

// Eliminar usuario
export async function DeleteUsuario(idUsuario) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/usuario/${idUsuario}`, {
    method: "DELETE",
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message);
  }
  return data.isDeleted;
}

// Cambiar estado de usuario (activar/desactivar)
export async function EstadoUsuario(usuarioObject) {
  const { IdUsuario, motivo } = usuarioObject;
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/updateEstado`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      idUsuario: IdUsuario,
      motivo: motivo,
    }),
  });
  const data = await response.json();
  if (!response.ok) {
    Swal.fire({
      title: "¡Error!",
      text: `${data.messege}`,
      icon: "error",
      confirmButtonText: "Ok",
    });
    console.log(data.messege);
    throw new Error("No se puede dar de alta/baja a este usuario");
  }
  return data;
}